import { Apis, Client, Lock, LockAction } from '../../../data'

export class LockAccess {
  public static async lock(id: string, action: LockAction): Promise<Lock> {
    return await Client
      .instance(await Apis.getGatewayV1())
      .get<Lock>("locks", { id }, { action })
  }
}
